module.exports = __webpack_public_path__ + "united-kingdom.svg?e5564902e2642c5e6e2e98e68a7d41f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/united-kingdom.svg
// module id = 331
// module chunks = 10